import createRequest from "@/utils/request"
import config from "@/config"
// TODO
// 获取用户基本信息
const getUserBaseInfo = () =>
    createRequest("SAPI").post(`/common/user/get-base-info?platform_id=${config.api["PID"]}`)

const getPermission = () =>
    createRequest("PAPI").get(`/openapi/my-permission?platform_id=${config.api["PID"]}`)

// 获取全员信息
const getUserList = (need_leave_user = false, need_user = true, need_pre_entry = false) =>
    createRequest("SAPI").post(
        `/common/organization/get-all-org-user?platform_id=${config.api.PID}`,
        {
            need_org: true,
            need_user: need_user,
            need_pre_entry: need_pre_entry,
            need_leave_user: need_leave_user,
            ...(need_leave_user ? { leave_user_type: 0 } : {})
        }
    )

const getAllUserList = () =>
    createRequest("SAPI").get(`/common/user/list?platform_id=${config.api.PID}`)

// 微信jsconfig签名
const getJSAPISig = (payload: {
    noncestr: string
    timestamp: number
    url: string
    is_agent: boolean
}) =>
    createRequest("SAPI").post(`/wechat/get-jsapi-signature?platform_id=${config.api["PID"]}`, {
        ...payload,
        agent_id: config.api["WXAPPID"]
    })

const getOrgList = (need_leave_user = false) =>
    createRequest("SAPI").post(
        `/common/organization/get-all-org-user?platform_id=${config.api.PID}`,
        {
            need_org: true,
            need_user: false,
            need_leave_user: need_leave_user,
            ...(need_leave_user ? { leave_user_type: 0 } : {})
        }
    )
// 根据uid批量获取人员
const getUserListByUids = (params: any) =>
    createRequest("SAPI").post(
        `/common/user/get-list-by-id?platform_id=${config.api["PID"]}`,
        params
    )
export default {
    getUserBaseInfo,
    getPermission,
    getUserList,
    getJSAPISig,
    getAllUserList,
    getOrgList,
    getUserListByUids
}
